var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { pluralize } from 'ember-inflector';
import { inject as service } from '@ember/service';
import BaseChannel from '@square/dashboard-data/adapters/channels/base-channel';
let ObjectMap = (_class = class ObjectMap extends BaseChannel {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "namespace", 'api/v1');
    _initializerDefineProperty(this, "store", _descriptor, this);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  pathForType(type) {
    return pluralize(type);
  }
  async enableListingStatus(ids) {
    const url = `${this.buildURL('channels/object-map', null)}/enable`;
    await this.ajax(url, 'POST', {
      data: {
        ids: ids.map(Number)
      }
    });
    ids.forEach(id => {
      this.store.push({
        data: {
          type: 'channels/object-map',
          id,
          attributes: {
            manuallyDisabled: false
          }
        }
      });
    });
  }
  async disableListingStatus(ids) {
    const url = `${this.buildURL('channels/object-map', null)}/disable`;
    await this.ajax(url, 'POST', {
      data: {
        ids: ids.map(Number)
      }
    });
    ids.forEach(id => {
      this.store.push({
        data: {
          type: 'channels/object-map',
          id,
          attributes: {
            manuallyDisabled: true
          }
        }
      });
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "store", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { ObjectMap as default };